<div [class.loader-hidden]="!show">
  <div class="loader-overlay" [ngClass]="{'backgroundAnimated': show}">
    <div fxFill fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px">
      <mat-spinner [color]="color" [strokeWidth]="strokeWidth" [diameter]="diameter"></mat-spinner>
      <div *ngIf="showText !== null">
        <span>{{ showText }}</span>
      </div>
    </div>
  </div>
</div>